type ChannelName =
  | 'update_ready'
  | 'requests_queue_length'
  | 'requests_queue_length_start'
  | 'notify_sw_api_status_change'
  | 'notify_client_api_status_change'
  | 'notify_client_is_sw_ready'
  | 'log'
  | 'cached_images_queue_length';

export function createMessageListener<T>(channelName: ChannelName, onMessage: (message: T) => void): () => void {
  const channel = new BroadcastChannel(channelName);

  const handleMessage = (event: MessageEvent<T>) => onMessage(event.data);

  channel.addEventListener('message', handleMessage);

  return () => {
    channel.removeEventListener('message', handleMessage);
    channel.close();
  };
}

export function sendMessage(channelName: ChannelName, data: unknown) {
  const channel = new BroadcastChannel(channelName);
  channel.postMessage(data);
  channel.close();
}
